"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var checkoutForm;
var checkoutPageConfirmation = /** @class */ (function () {
    function checkoutPageConfirmation() {
        this.$total = null;
        this.$postCard = null;
        this.$envelope = null;
        this.$flipBtn = null;
        this.$fontTypeInput = null;
        this.$promoCodeInput = null;
        this.$total = $('.js-total');
        this.$postCard = $('.js-post-card');
        this.$envelope = $('#envelope');
        this.$flipBtn = $('.js-flip-card');
        this.$fontTypeInput = $('.js-font-type');
        this.$promoCodeInput = $('.js-promo-code');
        this.toggleEnvelope();
        this.rotateCard();
        this.toggleCardFonts();
        if (this.$promoCodeInput.length > 0) {
            this.togglePromoCodeSubmitBtn();
            this.validatePromoCode();
        }
    }
    checkoutPageConfirmation.getInstance = function () {
        return new checkoutPageConfirmation();
    };
    checkoutPageConfirmation.prototype.toggleEnvelope = function () {
        var $envelope = this.$postCard, $envelopeCheckbox = this.$envelope, _self = this;
        var attr = ['card', 'envelope'];
        $envelopeCheckbox.on('change', function () {
            $envelope.toggleClass('show-envelope');
            _self.toggleTotal(attr.reverse()[0]);
        });
    };
    checkoutPageConfirmation.prototype.toggleTotal = function (type) {
        var cardPrice = $('body').find('.js-total').attr('data-card-price'), envelopePrice = $('body').find('.js-total').attr('data-envelope-price'), total;
        if (type == 'card') {
            this.$total.text(cardPrice);
        }
        else {
            total = parseFloat(cardPrice.replace(',', '.')) + parseFloat(envelopePrice.replace(',', '.'));
            this.$total.text(total.toFixed(2).replace('.', ','));
        }
    };
    checkoutPageConfirmation.prototype.rotateCard = function () {
        var $flip = this.$flipBtn, $cardWrapper = this.$postCard.find('.checkout__post-card-wrapper');
        $flip.on('click', function (e) {
            e.preventDefault();
            $cardWrapper.toggleClass('flip');
        });
    };
    checkoutPageConfirmation.prototype.toggleCardFonts = function () {
        var $fontTypes = this.$fontTypeInput, $cardContent = this.$postCard.find('.post-card__content');
        $fontTypes.on('change', function () {
            var font = 'font' + $(this).val();
            $cardContent.removeClass('font1 font2 font3 font4');
            $cardContent.addClass(font);
        });
    };
    checkoutPageConfirmation.prototype.togglePromoCodeSubmitBtn = function () {
        var $promoCodeInput = this.$promoCodeInput, $promoSubmitBtn = $promoCodeInput.parents('.promo-code').find('.btn');
        $promoCodeInput.on('input', function () {
            if ($(this).val().toString().length > 3) {
                $promoSubmitBtn.removeAttr('disabled');
                return;
            }
            $promoSubmitBtn.attr('disabled', true);
        });
    };
    checkoutPageConfirmation.prototype.validatePromoCode = function () {
        var $requestForm = this.$promoCodeInput.parents('form'), url = this.$promoCodeInput.attr('data-submit-url'), $promoCodeFormField = this.$promoCodeInput.parents('.input'), $promoSubmitBtn = this.$promoCodeInput.parents('.promo-code').find('.btn'), $envelopePrice = $('.js-envelope-price'), $totalPrice = this.$total;
        $promoSubmitBtn.on('click', function (e) {
            e.preventDefault();
            $promoCodeFormField.removeClass('promo-code__input--error');
            $promoCodeFormField.find('.field__error').remove();
            $.ajax(url, {
                method: 'POST',
                dataType: 'JSON',
                data: $requestForm.serialize(),
                success: function (response) {
                    if (response.status === 'free') {
                        window.location.replace(response.url);
                    }
                    if (response.status === 'discount_code' && response.discountApplied) {
                        $envelopePrice.html(response.prices.envelope_message);
                        $totalPrice.html(response.prices.total);
                        $totalPrice.attr('data-card-price', response.prices.total);
                        $totalPrice.attr('data-envelope-price', response.prices.envelope_price);
                    }
                },
                error: function (response) {
                    var msg = response.responseJSON.errors.promo_code;
                    $promoCodeFormField.addClass('promo-code__input--error');
                    $promoCodeFormField.find('label').append('<div class="error">' + msg + '</div>');
                }
            });
        });
    };
    return checkoutPageConfirmation;
}());
exports.default = checkoutPageConfirmation;
